import React from "react";
import GenericModal from "components/MainApp/atoms/Modals/GenericModal";
import { Button } from "@material-ui/core";

import styles from "./BatchTagsErrorModal.module.scss";
import i18n from "i18n";
const BatchTagsErrorModal = ({ open, handleClose, handleDownload}) => {
    const content = <div className={styles["batch-tags-error-content"]}>
        <div className={styles["icon-div"]}><i className={`${styles["icon-error"]} icon-iconos_alerta`}></i></div>
        <div className={styles["batch-tags-error-title"]}>{i18n.t("incorrect.content")}</div>
        <div className={styles["batch-tags-error-subtitle"]}>{i18n.t("see.errors.file")}</div>
        <div className={styles["batch-tags-error-buttons"]}>
            <div onClick={handleDownload}>
              <i className={`${styles["wrong-content-modal-icon"]} icon-iconos_descargar`}></i>
              {i18n.t("download.summary")}
            </div>
        </div>
        <div className={styles["btn-close-wrapper"]}>
               <Button className={styles["btn-close"]} onClick={handleClose}>{i18n.t("close").toUpperCase()}</Button>
            </div>
    </div>
    return (
      <div className={styles["batch-tags-error-container"]}>
          <GenericModal
            open={open}
            content={content}
            handleClose={handleClose}></GenericModal>
      </div>
    );
}


export default BatchTagsErrorModal;